@if ((membership$ | async); as membership) {
  <div>
    <!-- Top bar: status, toggle, portal link -->
    <div class="flex flex-row items-center justify-between flex-wrap gap-2 pb-8">
      <div class="text-sm text-slate-700">
        Current Status: <strong>
        @if (membership.status == 'Trial') {
          <span>Pro:Trial</span>
        }
        @if (membership.status == 'Active') {
          <span>Pro</span>
        }
        @if (membership.status == 'Free') {
          <span>Free</span>
        }
        @if ((this.licenseHasTeams$ | async) == true) {
          <span class="ml-1">[Teams]</span>
        }
      </strong>
    </div>
    <!-- Billing Toggle -->
    <div class="flex items-center space-x-3">
      <span class="text-sm font-medium" [style.color]="this.product_yearly ? '#94a3b8' : '#475569'">Monthly</span>
      <button type="button" class="relative inline-flex items-center h-7 w-12 rounded-full border-0 cursor-pointer p-0 focus:outline-none"
        [style.background-color]="this.product_yearly ? '#1E6EB7' : '#cbd5e1'"
        style="transition: background-color 0.2s ease;"
        (click)="this.product_yearly = !this.product_yearly">
        <span class="inline-block h-5 w-5 rounded-full bg-white shadow"
          [style.transform]="this.product_yearly ? 'translateX(1.375rem)' : 'translateX(0.25rem)'"
        style="transition: transform 0.2s ease;"></span>
      </button>
      <span class="text-sm font-medium" [style.color]="this.product_yearly ? '#475569' : '#94a3b8'">Yearly</span>
    </div>
    @if (!this.promotion) {
      <div>
        @if ({ url: this.portal$ | async}; as portal) {
          <a class="inline-flex items-center gap-1 text-sm text-brand font-medium hover:underline"
            target="_blank" [href]="portal.url"
            title="Customer billing portal (via Stripe)"
            [class.pointer-events-none]="!portal.url"
            [class.opacity-50]="!portal.url"
            >
            <fa-icon icon="address-card"></fa-icon>
            Customer Billing Portal
          </a>
        }
      </div>
    }
  </div>
  <!-- Error -->
  @if (error) {
    <div class="bg-red-50 text-red-700 text-sm rounded-lg p-3 mb-4">
      {{error}} <button class="ml-2 underline font-medium" (click)="retry()">Retry</button>
    </div>
  }
  <!-- Pricing Grid -->
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch pb-4">
    <!-- Free Plan -->
    <section class="bg-white rounded-lg p-6 flex flex-col shadow">
      <div class="mb-6">
        <span class="text-brand font-bold text-xs tracking-widest uppercase">Individual</span>
        <h3 class="text-3xl font-bold mt-2 text-slate-900">Free</h3>
        <p class="text-slate-600 mt-2 text-sm leading-relaxed">For makers tracking their first workflows.</p>
      </div>
      <div class="mb-6 flex items-baseline">
        <span class="text-3xl font-bold text-slate-900">$0</span>
        <span class="text-slate-500 text-sm ml-1">/forever</span>
      </div>
      <div class="mb-8 flex-grow">
        <app-about-fs-free [showTiles]="!this.dialogRef"></app-about-fs-free>
      </div>
    </section>
    <!-- Pro Plan (Featured) -->
    <section class="relative bg-white border-4 border-brand rounded-lg p-6 flex flex-col shadow-xl z-10 md:scale-105"
      style="border-style: solid;">
      <!-- Badge -->
      <div class="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand text-white text-[10px] font-bold tracking-widest uppercase py-1 px-4 rounded-full">
        Most Popular
      </div>
      <div class="mb-6">
        <span class="text-brand font-bold text-xs tracking-widest uppercase">Pro Maker</span>
        <h3 class="text-3xl font-bold mt-2 text-slate-900">Pro</h3>
        <p class="text-slate-600 mt-2 text-sm leading-relaxed">Advanced monitoring for professional developers.</p>
      </div>
      <div class="mb-6 flex items-baseline">
        @if (!this.product_yearly) {
          <span class="text-3xl font-bold text-slate-900">${{this.constants.pro_monthly}}</span>
        }
        @if (this.product_yearly) {
          <span class="text-3xl font-bold text-slate-900">${{this.constants.pro_yearly}}</span>
        }
        <span class="text-slate-500 text-sm ml-1">{{this.product_yearly ? '/year' : '/month'}}</span>
        @if (coupon) {
          <span class="text-slate-500 text-sm ml-2">({{this.couponText}})</span>
        }
      </div>
      <div class="mb-4 flex-grow">
        <app-about-fs-pro [showTiles]="!this.dialogRef"></app-about-fs-pro>
      </div>
      <div class="text-xs text-slate-500 mb-4">
        14 days free trial — cancel any time
        @if (coupon) {
          <div class="font-bold text-slate-700 mt-1">Coupon: {{this.coupon}}</div>
        }
      </div>
      <button (click)="openProHandler()"
        class="w-full py-3 px-4 bg-brand text-white font-semibold rounded-lg hover:bg-brand-dark transition-colors border-0"
        [disabled]="membership.status !== 'Free'"
        [class.opacity-50]="membership.status !== 'Free'"
        [class.cursor-not-allowed]="membership.status !== 'Free'">
        Subscribe Pro
      </button>
    </section>
    <!-- Teams Plan -->
    <section class="bg-white rounded-lg p-6 flex flex-col shadow">
      <div class="mb-6">
        <span class="text-brand font-bold text-xs tracking-widest uppercase">Enterprise</span>
        <h3 class="text-3xl font-bold mt-2 text-slate-900">Teams</h3>
        <p class="text-slate-600 mt-2 text-sm leading-relaxed">Full governance for IT teams and departments.</p>
      </div>
      <div class="mb-6 flex items-baseline">
        @if (!this.product_yearly) {
          <span class="text-3xl font-bold text-slate-900">${{this.constants.teams_monthly}}</span>
        }
        @if (this.product_yearly) {
          <span class="text-3xl font-bold text-slate-900">${{this.constants.teams_yearly}}</span>
        }
        <span class="text-slate-500 text-sm ml-1">{{this.product_yearly ? '/year' : '/month'}}</span>
      </div>
      <div class="mb-4 flex-grow">
        <app-about-fs-teams [showTiles]="!this.dialogRef"></app-about-fs-teams>
      </div>
      <div class="text-xs text-slate-500 mb-4">
        14 days free trial — cancel any time<br>
        Includes 3 FlowStudio Pro licenses, and up to 20 monitored flows.
      </div>
      <button (click)="openTeamsHandler()"
        class="w-full py-3 px-4 border border-brand bg-white text-brand font-semibold rounded-lg hover:bg-brand hover:text-white transition-colors"
        style="border-style: solid;"
        [disabled]="(this.licenseHasTeams$ | async) == true"
        [class.opacity-50]="(this.licenseHasTeams$ | async) == true"
        [class.cursor-not-allowed]="(this.licenseHasTeams$ | async) == true">
        Subscribe Teams
      </button>
    </section>
  </div>
</div>
}
